


export default function validatePhone( phoneField, country ) {
  const
    franceRegex = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/,
    spainRegex = /^(\+34|0034)?[6|7|8|9][0-9]{8}$/,
    portugalRegex = /^(\+351|00351)?[2|9][0-9]{8}$/,
    italyRegex = /^(((\+|00)39)|0*?)((0{1}[1-9]{1}(\d{4}\d{3,4}))|(38[890]|34[7-90]|36[680]|33[3-90]|32[89])(\d{6,7}$))/,
    ukRegex = /^(?:(?:\+|00)44|0)?[1|2|3|5|7][0-9]{8,9}$/,
    belgiumRegex = /^(?:(?:\+|00)32|0)?[1-9]{1}[0-9]{1}[0-9]{6,7}$/,
    mexicoRegex = /^(?:(?:\+|00)52)?\s*[0-9]{10}$/,
    irelandRegex = /^(?:(?:\+|00)353|0)?\s*[0-9]{1,2}\s*[0-9]{3}\s*[0-9]{4}$/,
    japanRegex = /^(0|\+81)\-?[0-9]{1,2}\-?[0-9]{4}\-?[0-9]{4}$/,
    brazilRegex = /^([0-9]{2,2}[-]?)?([2-9]{1}[0-9]{4}[-]?[0-9]{4})$/,
    austriaRegex = /^(\+43|0043)?\s*[0]{0,1}[0-9]{2}\s*[0-9]{6,9}$/,
    universalRegex = /^(00|\+)?[0-9]{2,3}?((\-|\s|\.|\/)?[0-9]){4,13}$/, //Some countries don't want callback requests to be filtered by country code
    value = phoneField.value.replace( /\s/g, '' ),
    formGroup = phoneField.closest( '.form-group' );

  switch ( country ) {
  case 'FR':
    if ( franceRegex.test( value )) {
      formGroup.classList.remove( 'form-group--has-danger' );
      formGroup.classList.add( 'form-group--has-success' );
      return true;
    }
    break;
  case 'ES':
    if ( spainRegex.test( value )) {
      formGroup.classList.remove( 'form-group--has-danger' );
      formGroup.classList.add( 'form-group--has-success' );
      return true;
    }
    break;
  case 'PT':
    if ( portugalRegex.test( value )) {
      formGroup.classList.remove( 'form-group--has-danger' );
      formGroup.classList.add( 'form-group--has-success' );
      return true;
    }
    break;
  case 'IT':
    if ( italyRegex.test( value )) {
      formGroup.classList.remove( 'form-group--has-danger' );
      formGroup.classList.add( 'form-group--has-success' );
      return true;
    }
    break;
  case 'GB':
    if ( ukRegex.test( value )) {
      formGroup.classList.remove( 'form-group--has-danger' );
      formGroup.classList.add( 'form-group--has-success' );
      return true;
    }
    break;
  case 'BE':
    if ( belgiumRegex.test( value )) {
      formGroup.classList.remove( 'form-group--has-danger' );
      formGroup.classList.add( 'form-group--has-success' );
      return true;
    }
    break;
  case 'MX':
    if ( mexicoRegex.test( value )) {
      formGroup.classList.remove( 'form-group--has-danger' );
      formGroup.classList.add( 'form-group--has-success' );
      return true;
    }
    break;
  case 'IE':
    if ( irelandRegex.test( value )) {
      formGroup.classList.remove( 'form-group--has-danger' );
      formGroup.classList.add( 'form-group--has-success' );
      return true;
    }
    break;
  case 'JP':
    if ( japanRegex.test( value )) {
      formGroup.classList.remove( 'form-group--has-danger' );
      formGroup.classList.add( 'form-group--has-success' );
      return true;
    }
    break;
  case 'BR':
    if ( brazilRegex.test( value )) {
      formGroup.classList.remove( 'form-group--has-danger' );
      formGroup.classList.add( 'form-group--has-success' );
      return true;
    }
    break;
  case 'AT':
    if ( austriaRegex.test( value )) {
      formGroup.classList.remove( 'form-group--has-danger' );
      formGroup.classList.add( 'form-group--has-success' );
      return true;
    }
    break;
  default:
    console.warn( 'A country code must be provided. Check that your site OpenGraph country-name is correctly set' );
    break;
  }

  formGroup.classList.remove( 'form-group--has-success' );
  formGroup.classList.add( 'form-group--has-danger' );
  return false;
}
